/* eslint-disable react/jsx-props-no-spreading, max-len */
import Icon from '../components/Icon'
import categories from './categories'

function ArrowUpArchive(props) {
  return (
    <Icon {...props}>

      <g><g><g><path d="M20.55,5.22l-1.39-1.68C18.88,3.21,18.47,3,18,3H6C5.53,3,5.12,3.21,4.85,3.55L3.46,5.22C3.17,5.57,3,6.01,3,6.5V19 c0,1.1,0.89,2,2,2h14c1.1,0,2-0.9,2-2V6.5C21,6.01,20.83,5.57,20.55,5.22z M12,9.5l5.5,5.5H14v2h-4v-2H6.5L12,9.5z M5.12,5 l0.82-1h12l0.93,1H5.12z" /></g></g></g>
    </Icon>
  )
}

ArrowUpArchive.tags = ['Unarchive']
ArrowUpArchive.category = categories.actions

export default ArrowUpArchive
